'use client'

import { useMemo, useRef, useState } from 'react'
import Image from 'next/image'

import { CloseFooterIcon, Dialog, PlayPdpIcon } from '@/components'

import { InterviewVideoType } from '../types'

const InterviewVideo = ({ blockData: data }: { blockData: string }) => {
  const [open, setOpen] = useState(false)
  const videoRef = useRef<HTMLVideoElement>(null)
  const blockData = useMemo(() => {
    if (data) {
      return JSON.parse(data) as InterviewVideoType
    }
  }, [data])

  const handleClick = () => {
    setOpen(true)
    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.play()
      }
    }, 0)
  }

  const handleClose = () => {
    if (videoRef.current) {
      videoRef.current.pause()
    }
    setOpen(false)
  }

  return (
    <div className="mt-7 px-3 max-xl:px-0 xl:mt-11">
      {/* pc端 */}
      <div className="mx-auto max-w-[1440px] max-xl:hidden">
        <div className="max-w-[780px]">
          <h2
            className="!mb-4 !mt-0 font-miSansSemiBold520 !text-pc-h1 !font-medium text-black"
            dangerouslySetInnerHTML={{ __html: blockData?.title || '' }}></h2>
          <p
            className="mt-4 font-miSansMedium380 !text-pc-2xl text-gray-5"
            dangerouslySetInnerHTML={{ __html: blockData?.subtitle || '' }}></p>
        </div>
        <div className="relative mt-11 aspect-[1440/576] w-full overflow-hidden rounded-xl">
          {blockData?.video ? (
            <video
              src={blockData?.video}
              poster={blockData?.video_image_pc}
              playsInline
              autoPlay
              muted
              loop
              controlsList="nopictureinpicture"
              className="w-full"></video>
          ) : (
            <Image
              src={blockData?.video_image_pc || ''}
              width={1440}
              height={576}
              className="w-full"
              alt=""
            />
          )}
          {blockData?.popup_video && (
            <div
              className="absolute bottom-[4%] left-1/2 flex translate-x-[-50%] cursor-pointer items-center gap-3 rounded-full bg-[#00000066] px-7 py-[13px] backdrop-blur-[10px]"
              onClick={() => handleClick()}>
              <PlayPdpIcon />
              <span className="font-miSansDemiBold450 text-2xl text-white">Reproducir vídeo</span>
            </div>
          )}
        </div>
        {blockData?.pc_image && (
          <div className="mt-14 overflow-hidden rounded-xl">
            <Image
              width={1440}
              height={772}
              style={{ objectFit: 'cover' }}
              src={blockData?.pc_image || ''}
              alt={blockData?.title || ''}
              className="h-auto w-full"
            />
          </div>
        )}
      </div>
      {/* mb端 */}
      <div className="xl:hidden">
        <div className="relative h-[576px] w-full overflow-hidden xl:rounded-xl">
          {blockData?.video ? (
            <video
              src={blockData?.video}
              poster={blockData?.video_image_mob}
              autoPlay
              muted
              playsInline
              loop
              controlsList="nopictureinpicture"
              className="h-full w-full object-cover object-center"></video>
          ) : (
            <Image
              src={blockData?.video_image_mob || ''}
              width={375}
              height={576}
              className="w-full"
              alt=""
            />
          )}
          <div className="absolute left-0 right-0 top-10 mx-auto flex max-w-[80%] flex-col items-center text-center">
            <div className="max-w-[310px]">
              <h2
                className="!mb-2 !mt-0 font-miSansDemiBold450 !text-5xl text-white"
                dangerouslySetInnerHTML={{ __html: blockData?.title || '' }}></h2>
              <p
                className="!mb-0 font-miSansMedium380 !text-pc-lg text-white"
                dangerouslySetInnerHTML={{ __html: blockData?.subtitle || '' }}></p>
            </div>
            {blockData?.popup_video && (
              <div
                className="mt-6 flex cursor-pointer items-center gap-2 rounded-full bg-[#00000066] px-3 py-2 backdrop-blur-[10px]"
                onClick={() => handleClick()}>
                <PlayPdpIcon width={20} height={20} />
                <span className="font-miSansMedium380 text-base text-white">Reproducir vídeo</span>
              </div>
            )}
          </div>
        </div>

        {blockData?.mob_image && (
          <div className="mt-7 overflow-hidden rounded-lg max-xl:px-3">
            <Image
              width={350}
              height={294}
              src={blockData?.mob_image || ''}
              alt={blockData?.title || ''}
              className="h-auto w-full rounded-lg"
            />
          </div>
        )}
      </div>
      <Dialog
        containerStyle="w-full h-full !rounded-[0] flex justify-center items-center xl:bg-[#000000A6] backdrop-blur-[12px] bg-black max-xl:p-0"
        open={open}
        onOpenChange={() => {}}
        hasCloseIcon={false}>
        <div className="relative m-auto w-full max-w-[1440px] xl:overflow-hidden xl:rounded-xl">
          <div
            className="absolute right-7 top-7 z-[1] flex h-9 w-9 cursor-pointer items-center justify-center rounded-full bg-[#00000066] backdrop-blur-[28px] max-xl:hidden"
            onClick={handleClose}>
            <CloseFooterIcon rotate={45} width={16} height={16} color="#FFFFFF" />
          </div>
          <div
            className="absolute right-3 top-[-40px] z-[1] flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-[#FFFFFF4D] backdrop-blur-[28px]"
            onClick={handleClose}>
            <CloseFooterIcon rotate={45} width={12} height={12} color="#FFFFFF" />
          </div>
          <video
            ref={videoRef}
            src={blockData?.popup_video}
            poster={blockData?.video_image_pc}
            playsInline
            controls
            // controlsList="nopictureinpicture"
            className="m-auto w-full"></video>
        </div>
      </Dialog>
    </div>
  )
}

export default InterviewVideo
